'use client';

import dayjs from 'dayjs';
import { useState } from 'react';
import type { Dictionary } from '@/lib/server/getDictionary';

type Props = {
  serialNumber: string;
  placedAt?: string | null;
  dictionary: Dictionary;
};

export function TrackingNumberBox({ serialNumber, placedAt, dictionary }: Props) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(serialNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard permission denied or unavailable — nothing sensible to fall back to
    }
  }

  return (
    <div className="flex flex-col items-start gap-1 md:items-end">
      <div className="flex items-center gap-2 rounded-xl border border-outline-variant bg-surface px-4 py-3 md:border-0 md:bg-transparent md:p-0">
        <div>
          <p className="text-xs text-on-surface-variant md:text-right">
            {dictionary.general.trackingNumber}
          </p>
          <p className="font-mono text-sm font-semibold tracking-wide md:text-right">{serialNumber}</p>
        </div>
        <button
          type="button"
          onClick={handleCopy}
          className="rounded-lg p-2 text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface"
          aria-label={dictionary.general.copy}
        >
          {copied ? (
            <span className="text-xs font-medium text-primary">{dictionary.general.copied}</span>
          ) : (
            <span className="material-symbols-outlined text-base">content_copy</span>
          )}
        </button>
      </div>
      {placedAt && (
        <p className="text-xs text-on-surface-variant">
          {dictionary.order.placed} {dayjs(placedAt).format('DD MMM YYYY')}
        </p>
      )}
    </div>
  );
}
